import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { UtilitiesService } from '../../../services/utilities/utilities.service';

@Pipe({
  name: 'convertHtml',
  pure: true
})
export class ConvertHtmlPipe implements PipeTransform {
  constructor(private util: UtilitiesService, private sanitizer: DomSanitizer) { }

  transform(value: string | null | undefined): SafeHtml {
    if (!value) return '';
    const decoded = this.util.setHtmlContent(value);
    const sanitized = this.sanitizeHtml(decoded);
    return this.sanitizer.bypassSecurityTrustHtml(sanitized);
  }

  private sanitizeHtml(html: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const allowedTags = new Set([
      'a', 'b', 'i', 'strong', 'em', 'span', 'p', 'div', 'br', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
    ]);
    const allowedAttributes = new Set([
      'class', 'id', 'href', 'target', 'data-auto-id'
    ]);

    const sanitizeElement = (node: Node): Node | null => {
      if (node.nodeType === Node.TEXT_NODE) {
        return node.cloneNode(true);
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        const el = node as Element;
        const tagName = el.tagName.toLowerCase();

        if (!allowedTags.has(tagName)) {
          if (tagName === 'script' || tagName === 'iframe' || tagName === 'object' || tagName === 'embed' || tagName === 'style') {
            return null;
          }
          const fragment = doc.createDocumentFragment();
          for (let i = 0; i < el.childNodes.length; i++) {
            const sanitizedChild = sanitizeElement(el.childNodes[i]);
            if (sanitizedChild) {
              fragment.appendChild(sanitizedChild);
            }
          }
          return fragment;
        }

        const cleanEl = doc.createElement(tagName);

        for (let i = 0; i < el.attributes.length; i++) {
          const attr = el.attributes[i];
          const attrName = attr.name.toLowerCase();

          if (allowedAttributes.has(attrName) && !attrName.startsWith('on')) {
            const attrValue = attr.value;
            if (attrName === 'href') {
              const trimmedValue = attrValue.trim().toLowerCase();
              if (trimmedValue.startsWith('javascript:') || trimmedValue.startsWith('data:')) {
                continue;
              }
            }
            cleanEl.setAttribute(attr.name, attrValue);
          }
        }

        for (let i = 0; i < el.childNodes.length; i++) {
          const sanitizedChild = sanitizeElement(el.childNodes[i]);
          if (sanitizedChild) {
            cleanEl.appendChild(sanitizedChild);
          }
        }

        return cleanEl;
      }

      return null;
    };

    const cleanFragment = doc.createDocumentFragment();
    const body = doc.body;
    for (let i = 0; i < body.childNodes.length; i++) {
      const sanitizedChild = sanitizeElement(body.childNodes[i]);
      if (sanitizedChild) {
        cleanFragment.appendChild(sanitizedChild);
      }
    }

    const tempDiv = doc.createElement('div');
    tempDiv.appendChild(cleanFragment);
    return tempDiv.innerHTML;
  }
}

